import React from "react";
import { CalendarClock, Sun, AlertTriangle, CircleSlash, HelpCircle } from "lucide-react";
import { cueStatus } from "../lib/resurface";

const TONE = {
  overdue: { cls: "bg-[var(--amber-soft)] text-[var(--amber-text)] border-[var(--amber-soft)]", Icon: AlertTriangle },
  today: { cls: "bg-[var(--amber-soft)] text-[var(--amber-text)] border-[var(--amber-soft)]", Icon: Sun },
  future: { cls: "bg-[var(--pine-soft)] text-[var(--pine)] border-[var(--pine-line)]", Icon: CalendarClock },
  horizon: { cls: "bg-[var(--pine-soft)] text-[var(--pine)] border-[var(--pine-line)]", Icon: CalendarClock },
  window: { cls: "bg-[var(--pine-soft)] text-[var(--pine)] border-[var(--pine-line)]", Icon: CalendarClock },
  ambiguous: { cls: "bg-[var(--pine-soft)] text-[var(--pine)] border-[var(--pine-line)]", Icon: HelpCircle },
  none: { cls: "bg-[var(--line2)] text-[var(--ink3)] border-[var(--line)]", Icon: CircleSlash },
};

export default function CueStatus({ entry, testid }) {
  const { tone, label } = cueStatus(entry);
  const { cls, Icon } = TONE[tone] || TONE.none;
  return (
    <div
      data-testid={testid}
      data-cue-tone={tone}
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-xs font-semibold ${cls}`}
    >
      <Icon size={14} strokeWidth={1.9} />
      {label}
    </div>
  );
}
